import { render, staticRenderFns } from "./CapitalHolding.vue?vue&type=template&id=2c0ac9d8&scoped=true"
import script from "./CapitalHolding.vue?vue&type=script&lang=js"
export * from "./CapitalHolding.vue?vue&type=script&lang=js"
import style0 from "./CapitalHolding.vue?vue&type=style&index=0&id=2c0ac9d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0ac9d8",
  null
  
)

export default component.exports